import { render, staticRenderFns } from "./ProductListForm.vue?vue&type=template&id=92391100"
import script from "./ProductListForm.vue?vue&type=script&lang=js"
export * from "./ProductListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92391100')) {
      api.createRecord('92391100', component.options)
    } else {
      api.reload('92391100', component.options)
    }
    module.hot.accept("./ProductListForm.vue?vue&type=template&id=92391100", function () {
      api.rerender('92391100', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/product-list/ProductListForm.vue"
export default component.exports